package dairy.mynotes.registration

import androidx.compose.foundation.background
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import dairy.mynotes.navigation.Navigator
import dairy.mynotes.reusablecomponents.ButtonComponent
import dairy.mynotes.reusablecomponents.CircularProgressBarComponent
import dairy.mynotes.reusablecomponents.Label
import dairy.mynotes.reusablecomponents.TextButtonComponent
import dairy.mynotes.reusablecomponents.TextInputComponent
import dairy.mynotes.ui.theme.AppColors

@Composable
fun RegistrationScreen(navigator: Navigator? = null, registrationViewModel: RegistrationViewModel = androidx.lifecycle.viewmodel.compose.viewModel { RegistrationViewModel() }) {
    val uiState by registrationViewModel.uiState.collectAsState()
    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(AppColors.Background)
            .verticalScroll(rememberScrollState())
            .padding(top = 32.dp, start = 16.dp, end = 16.dp, bottom = 32.dp),
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.Start
    ) {
        Label(
            text = "Create account",
            textStyle = MaterialTheme.typography.headlineMedium,
            modifier = Modifier.padding(bottom = 8.dp)
        )

        Label(
            text = "Start capturing your thoughts",
            textStyle = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            modifier = Modifier.padding(bottom = 24.dp)
        )

        TextInputComponent(
            value = uiState.email,
            onValueChange = { registrationViewModel.onEmailChange(it) },
            label = "Email",
            modifier = Modifier.fillMaxWidth().padding(bottom = 16.dp),
            keyboardType = KeyboardType.Email
        )

        TextInputComponent(
            value = uiState.password,
            onValueChange = { registrationViewModel.onPasswordChange(it) },
            label = "Password",
            modifier = Modifier.fillMaxWidth().padding(bottom = 16.dp),
            keyboardType = KeyboardType.Password,
            visualTransformation = PasswordVisualTransformation(),
        )

        TextInputComponent(
            value = uiState.confirmPassword,
            onValueChange = { registrationViewModel.onConfirmPasswordChange(it) },
            label = "Re-enter Password",
            modifier = Modifier.fillMaxWidth().padding(bottom = 24.dp),
            keyboardType = KeyboardType.Password,
            visualTransformation = PasswordVisualTransformation(),
        )

        if (uiState.error != null) {
            Text(text = uiState.error!!, color = AppColors.Error, modifier = Modifier.padding(bottom = 16.dp))
        }

        if (uiState.isLoading) {
            CircularProgressBarComponent(modifier = Modifier.align(Alignment.CenterHorizontally))
            Spacer(modifier = Modifier.height(8.dp))
        }

        ButtonComponent(
            text = "Create Account",
            onClick = { registrationViewModel.register() },
            enabled = uiState.email.isNotEmpty() && uiState.password.isNotEmpty() &&
                    uiState.confirmPassword.isNotEmpty() &&
                    uiState.password == uiState.confirmPassword,
            modifier = Modifier.fillMaxWidth()
        )

        if (uiState.isRegistered) {
            navigator?.navigateToLogin()
        }

        Spacer(modifier = Modifier.height(24.dp))

        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Label(text = "Already have an account?", textStyle = MaterialTheme.typography.bodyMedium)
            TextButtonComponent(
                text = "Sign in",
                onClick = { navigator?.navigateToLogin() }
            )
        }
    }
}

@Composable
fun RegistrationScreenPreview() {
    androidx.compose.material3.MaterialTheme {
        RegistrationScreen()
    }
}

